import OrdersTable from './OrdersTable';
export default OrdersTable;
